export function modelToolHelpers(modelTool) {
    return {
        computed: {
            mediaTools() {
                return scoopOS.tools ? scoopOS.tools.medias : null;
            },
        },
        methods: {
            countApplicableModels(className) {
                if (!this.mediaTools || !this.mediaTools[className || modelTool]) {
                    return -1;
                }
                return this.mediaTools[className || modelTool].length;
            },
            allowedToSee(className) {
                return this.countApplicableModels(className || modelTool) >= 0;
            },
            applicableTo(className) {
                return this.countApplicableModels(className || modelTool) > 0;
            },
        }
    }
}
